import React, { useEffect, useState } from 'react';
import GlobalHeader from '@salesforce/design-system-react/components/global-header';
import GlobalHeaderProfile from '@salesforce/design-system-react/components/global-header/profile';
import { AuthConsumer } from 'contexts/auth-context';
import { SFConnection } from 'common/sf-connector';
import { CQAppConstant } from 'app-constants';
import { Button, Popover } from '@salesforce/design-system-react';

function CQGlobalHeader() {
  const authContext = AuthConsumer();
  const [userName, setUserName] = useState<string>('Loading...');
  const [avatar, setAvatar] = useState<string>();
  useEffect(() => {
    SFConnection.fetchUserName().then((details) => {
      setUserName(details.username);
      localStorage.setItem('loggedInUsername', details.username);
      setAvatar(details.photoUrl);
    })
  }, []);

  /**
   * Handles the logout process for the user.
   * Calls backend logout endpoint to revoke Salesforce token and clear cookies,
   * then clears the client-side auth context.
   */
  async function handleLogout(){
    try {
      await SFConnection.logOut();
    } catch (error) {
      console.error('[logout] backend logout failed', error);
    } finally {
      authContext.logout();
    }
  }
  
  return (
    <>
      {
        authContext.isAuthenticated ?
        <GlobalHeader logoSrc="/logo512.png">
            <GlobalHeaderProfile userName={userName} avatar={avatar} popover={
              <Popover
                body={
                    <Button
                      variant="base"
                      className="slds-text-link"
                      onClick={() => handleLogout()}
                    >
                      {CQAppConstant.LOG_OUT}
                    </Button>
                }
              />
            }></GlobalHeaderProfile>
        </GlobalHeader>
        : <></> }
    </>
  );
}

export default CQGlobalHeader;
